import { type ZodNull, type ZodString, z } from "zod";

export const ZodStringNullable = z.preprocess((val) => {
	if (val === undefined || val === "" || val === null || val === "null") return null;
	return val;
}, z.string().nullable()) as unknown as ZodString | ZodNull;
